import React from 'react';
import styles from './noResults.scss';

const NoResults = () =>
   (
     <hgroup className={styles.noResultsContent}>
       <h1 className={styles.noResultsTitle}>
         No results to show.
       </h1>
       <h2 className={styles.noResultsSubTitle}>
         Edit filter criteria to the left to see results.
       </h2>
     </hgroup>
  )
;
export default NoResults;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/components/noResults.jsx